/*
* @描述: 编辑订单
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/17 16:51
*/
<template>
    <van-popup v-model.sync="dialogVisible"
               :style="{ width: '100%',height: '100%' }">
        <div v-loading="loading" class="public_container">
            <div class="returnNavBar">
                <ReturnNavBar :isAllFunctions="false"
                              :isCustomReturnEvent="true"
                              :isTitleNormal="true"
                              title="返回"
                              @returnEvent="handleDialogClose"></ReturnNavBar>
            </div>
            <div class="detail_wrap_container">
                <CustomFormMobile v-if="dataLoaded&&formInfoList.length"
                                  ref="orderForm"
                                  :field_form="'orders'"
                                  :field_list="formInfoList"
                                  :form_detail="orderFormData"
                                  :is_form_module="true"
                                  :is_release="orderFormData.is_release"
                                  :pk_id="order_id"
                                  @getApproveNode="getApproveNode"
                                  @submit-form="submitOrderFormData"/>
                <div v-if="isApproval===1" class="add_approval_select_process">
                    <div class="m_page_little_title">
                        <span class="title">审批流程</span>
                    </div>
                    <div class="detail_chunk_wrap">
                        <approveProcessSelect ref="approveProcessSelectRef"
                                              :approval_node_list="approval_node_list">
                        </approveProcessSelect>
                    </div>
                </div>
            </div>
            <div class="add_footer_wrap">
                <van-button  v-if="orderFormData.is_release===0"
                             :disabled="btnDisabled||loading"
                             plain
                             type="info"
                             @click="handleDialogSave">保存
                </van-button>
                <van-button  :disabled="btnDisabled||loading"
                             size="large"
                             type="primary"
                             @click="handleDialogConfirm">提交
                </van-button>
            </div>
        </div>
        <van-dialog v-model="remarksDialog"
                    confirm-button-color="#2990FF"
                    confirm-button-text="确定"
                    show-cancel-button
                    title="修改原因"
                    @cancel="handleRemarksDialogClose"
                    @confirm="handleRemarksDialogConfirm">
            <van-field v-model="remarks"
                       :rows="5"
                       placeholder="请输入修改原因"
                       type="textarea"/>
        </van-dialog>
    </van-popup>
</template>
<script>
import CustomFormPc from "@/components/pComponents/CustomFormPc";
import PersonnelCard from "@/components/pComponents/PersonnelCard";
import approveProcessSelect from "@/components/pComponents/approveProcessSelect";
import {getFormFields, orderEdit, getApprovalNodes, orderDetail} from "@/api";
import {getBusinessIsApproval} from "@/utils";
import CustomFormMobile from "@/components/mComponents/CustomFormMobile.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";

export default {
    name: "OrderEdit",
    data() {
        return {
            formInfoList: [],
            orderFormData: {},
            isApproval: 0,
            is_release: 1,
            loading: false,
            importQuotationVisible: false,
            quotationData: [],
            searchForm: {
                keyword: '',
                quotation_at: [],
            },
            defaultImg: require('@/assets/images/default.jpg'),
            approval_node_list: [],
            dataLoaded: false,
            remarksDialog: false,
            btnDisabled: false,
            hasGetApproveNodes: false,
            remarks: '',
            form_version: ''
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        order_id: {
            type: Number,
            default: 0,
        },
    },
    components: {ReturnNavBar, CustomFormMobile, CustomFormPc, PersonnelCard, approveProcessSelect},
    created() {
        this._getFromFields()
    },
    methods: {
        _getFromFields() {
            this.loading = true
            getFormFields({
                field_form: 'orders'
            }).then(res => {
                if (res.code === 200) {
                    this.form_version = res.header_data["form-version"]
                    this.formInfoList = res.data
                    this.getOrderDetail()
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },

        getOrderDetail() {
            orderDetail({
                order_id: this.order_id
            },).then(res => {
                this.orderFormData = res.data
                this.is_release = res.data.is_release
                this.dataLoaded = true
                if (res.data.is_release === 0) {
                    getBusinessIsApproval('order_add').then(res => {
                        this.isApproval = res
                        if (this.isApproval === 1) {
                            getApprovalNodes({
                                approval_type: 'order_add',
                            }).then(res => {
                                if (res.code === 200) {
                                    this.approval_node_list = res.data
                                    this.$refs.approveProcessSelectRef.set_approval_node_list(res.data)
                                }
                                this.loading = false
                            }).catch(() => {
                                this.loading = false
                            })
                        }
                    })
                }
            })
        },

        // 关闭弹窗
        handleDialogClose() {
            this.$emit('update:dialogVisible', false)
        },

        //获取订单表单数据
        submitOrderFormData(data) {
            if (this.isApproval === 1 && !this.$refs.approveProcessSelectRef.handleClickPublish()) return false
            this.btnDisabled = true
            orderEdit({
                ...data,
                is_release: this.is_release,
                node_list: this.approval_node_list,
                order_id: this.order_id,
                after_sales_type: '订单售后-编辑', //售后类型
                order_num: this.orderFormData?.order_num,//	订单编号
                customer_name: this.orderFormData?.customer_id?.text,//关联客户
                remarks: this.remarks,
                project_quotation_id: this.orderFormData.project_quotation_id,
                goods_cost_price: data.order_goods.reduce((total, item) => {
                    // 只处理 type 为 1 的商品
                    if (item.type === 1) {
                        // 计算价格
                        const costPrice = Number(item.cost_price) || 0;
                        const num = Number(item.num) || 0;
                        return total + costPrice * num;
                    }
                    return total; // 如果不满足条件，保持总值不变
                }, 0)
            }, this.is_release === 0 ? {} : {'form-version': this.form_version}).then(res => {
                if (res.code === 200) {
                    this.$toast.success(this.is_release === 0 ? '保存成功' : '编辑成功')
                    this.handleDialogClose()
                } else {
                    this.btnDisabled = false
                }
            })
        },

        //获取订单审批流
        getApproveNode() {
            if (this.orderFormData.is_release === 1 && !this.hasGetApproveNodes) {
                this.hasGetApproveNodes = true
                getBusinessIsApproval('order_after_sale').then(res => {
                    this.isApproval = res
                    if (this.isApproval === 1) {
                        getApprovalNodes({
                            approval_type: 'order_after_sale',
                            form_value: {
                                order_after_sale: {
                                    value: 'order_edit'
                                }
                            }
                        }).then(res => {
                            if (res.code === 200) {
                                this.approval_node_list = res.data
                                this.$refs.approveProcessSelectRef.set_approval_node_list(res.data)
                            }
                            this.loading = false
                        }).catch(() => {
                            this.loading = false
                        })
                    }
                })
            }
        },

        //保存
        handleDialogSave() {
            this.is_release = 0
            this.$refs.orderForm.handleClickPublish(false)
        },

        // 确定
        handleDialogConfirm() {
            this.is_release = 1
            this.remarks = ''
            if (this.isApproval === 1 && !this.$refs.approveProcessSelectRef.handleClickPublish()) return false
            if (this.orderFormData.is_release === 1) {
                this.remarksDialog = true
            } else {
                this.$refs.orderForm.handleClickPublish()
            }
        },

        handleRemarksDialogClose() {
            this.remarks = ''
            this.remarksDialog = false
        },

        handleRemarksDialogConfirm() {
            if (!this.remarks) return this.$toast.fail('请输入修改原因')
            this.$refs.orderForm.handleClickPublish()
        },
    },
}
</script>
<style lang="scss" scoped>
.custom_form_body {
    height: 677px;
    padding: 24px;
}

.select_quotation_wrap {
    height: 600px;

    .flex_wrap {
        gap: 16px;
        margin-bottom: 16px;

        .el-input {
            flex: 1;
        }

        .el-date-editor {
            flex: 1;
        }
    }
}
</style>